//-------------------------------------------------------------------------------------------------- Imports
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import { Key, ReactNode, useState } from "react";
import { StyleSheet } from "../StyleSheet";

//-------------------------------------------------------------------------------------------------- Interfaces
interface ListAccordionItem {
    key: Key;
    title: string;
    children: ReactNode;
};

interface ListAccordionProps {
    items: Array<ListAccordionItem>;
    focus?: Key;
};

//-------------------------------------------------------------------------------------------------- Component
const ListAccordion = (props: ListAccordionProps) => {
    const { items, focus } = props;
    const [showElement, setShowElement] = useState<Key | undefined>(focus && focus);

    const handlePress = (key: Key) => {
        setShowElement((key !== showElement) ? key : undefined);
    };

    return (
        <Row style={styles.mainContainer}>
            {items.map(item => (
                <Card key={item.key} style={styles.cardStyles}>
                    <Row style={{ cursor: 'pointer' }} onClick={() => handlePress(item.key)}>
                        <Col style={styles.titleContainer}>
                            <h3 style={{ color: "#757982", fontWeight: 600 }}>{item.title}</h3>
                        </Col>
                        <Col style={styles.iconContainer}>
                            {(item.key === showElement) ? (
                                <UpOutlined style={styles.iconStyles} />
                            ) : (
                                <DownOutlined style={styles.iconStyles} />
                            )}
                        </Col>
                    </Row>
                    {(item.key === showElement) && (
                        <div style={styles.childrenContainer}>
                            {item.children}
                        </div>
                    )}
                </Card>
            ))}
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        width: "100%",
        flexDirection: "column",
    },
    cardStyles: {
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15
    },
    titleContainer: {
        flex: 1,
        display: "flex",
        height: "100%",
        alignItems: "center",
    },
    iconContainer: {
        display: "flex",
        width: 50,
        height: 50,
        alignItems: "center",
        justifyContent: "center",
    },
    iconStyles: {
        fontSize: 20,
    },
    childrenContainer: {
        display: "flex",
        width: "100%",
        marginTop: 20,
        alignItems: "center",
        justifyContent: "center",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export type { ListAccordionItem };
export default ListAccordion;
